import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { authApi, tokenManager } from '../../pages/login/api/auth';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // SSO: if a token was passed in the URL (from the portal), save it first
        const _params = new URLSearchParams(window.location.search);
        const _sso = _params.get('sso_token');
        if (_sso) {
          tokenManager.setToken(_sso);
          _params.delete('sso_token');
          const _clean = window.location.pathname + (_params.toString() ? '?' + _params.toString() : '');
          window.history.replaceState({}, '', _clean);
        }
        // Check if token exists
        if (!tokenManager.isAuthenticated()) {
          setIsAuthenticated(false);
          return;
        }

        // Verify token is still valid by making a request to /auth/me
        const _me = await authApi.getCurrentUser();
        // Save user so the topbar can show the name (needed after SSO login)
        if (_me) {
          try { localStorage.setItem('current_user', JSON.stringify(_me)); } catch (e) {}
        }
        setIsAuthenticated(true);
      } catch (error) {
        // Token is invalid or expired
        tokenManager.removeToken();
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="flex flex-col items-center">
          <svg className="animate-spin h-12 w-12 text-blue-600 mb-4" fill="none" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" className="opacity-25"></circle>
            <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" className="opacity-75"></path>
          </svg>
          <p className="text-gray-600">Verifying authentication...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Render protected content if authenticated
  return children;
};

export default ProtectedRoute; 